import { render } from "./EducationalSectionsList.vue?vue&type=template&id=4e150e34&scoped=true"
import script from "./EducationalSectionsList.vue?vue&type=script&lang=js"
export * from "./EducationalSectionsList.vue?vue&type=script&lang=js"

import "./EducationalSectionsList.vue?vue&type=style&index=0&id=4e150e34&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e150e34"]])

export default __exports__